import {
  DashboardIcon,
  UsersIcon,
  SettingsIcon,
  LogoutIcon,
} from "../../../assets/svgIcons";

/**
 * Sidebar navigation items configuration
 * Each item defines a tab with label, icon, and display settings
 */
export const sidebarItems = [
  {
    id: "dashboard",
    label: "Dashboard",
    icon: DashboardIcon,
  },
  {
    id: "users",
    label: "Form Submissions",
    icon: UsersIcon,
  },
  {
    id: "settings",
    label: "Settings",
    icon: SettingsIcon,
  },
];

/**
 * Export LogoutIcon component for use in Sidebar component
 */
export { LogoutIcon };
